import React from 'react';
import { FaTrash, FaTimes, FaExclamationTriangle } from 'react-icons/fa';

export default function DeleteConfirmationModal({ isOpen, user, onClose, onConfirm, deleting }) {
  if (!isOpen || !user) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '460px' }}
      >
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div
              style={{
                width: '36px',
                height: '36px',
                borderRadius: 'var(--radius-md)',
                background: 'rgba(239, 68, 68, 0.2)',
                color: 'var(--danger)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <FaExclamationTriangle />
            </div>
            <div>
              <h3 style={{ fontSize: '1.15rem' }}>Delete Confirmation</h3>
              <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                Permanent Account Removal
              </span>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'var(--text-muted)',
              cursor: 'pointer',
              fontSize: '1.2rem',
            }}
          >
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div
            style={{
              padding: '14px 16px',
              borderRadius: 'var(--radius-md)',
              background: '#fef2f2',
              border: '1px solid #fca5a5',
              color: '#991b1b',
              fontSize: '0.88rem',
              lineHeight: 1.5,
            }}
          >
            Are you sure you want to delete user{' '}
            <strong style={{ color: '#0f172a' }}>{user.name}</strong> (@{user.username})?
            <div style={{ fontSize: '0.78rem', color: '#64748b', marginTop: '8px' }}>
              This will remove all associated records from <code>user_area_access</code> and{' '}
              <code>user_website_access</code>.
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={deleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => onConfirm(user)}
            disabled={deleting}
          >
            <FaTrash />
            <span>{deleting ? 'Deleting...' : 'Delete User'}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
